/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 10.5L11 12.5L15.5 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 22V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622L6.27569 20.8622C8.37459 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L17.7243 20.8622L20 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M20 22V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622L6.27569 20.8622C8.37459 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L17.7243 20.8622L20 22Z"
				fill="currentColor"
			/>
			<path
				d="M9 10.5L11 12.5L15.5 8M20 22V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622C8.37458 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L20 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.98005 1.79497C7.04961 1.25 8.44974 1.25 11.25 1.25H12.75C15.5503 1.25 16.9504 1.25 18.02 1.79497C18.9608 2.27433 19.7257 3.03924 20.205 3.98005C20.75 5.04961 20.75 6.44974 20.75 9.25V21.9191C20.75 22.3477 20.75 22.562 20.6597 22.6911C20.5809 22.8038 20.4591 22.879 20.3231 22.8991C20.1673 22.9222 19.9756 22.8263 19.5922 22.6346L17.7243 21.7007C15.6254 20.6512 14.576 20.1265 13.4752 19.92C12.5002 19.7371 11.4998 19.7371 10.5248 19.92C9.42404 20.1265 8.37458 20.6512 6.27566 21.7007L4.40777 22.6346C4.02441 22.8263 3.83273 22.9222 3.67692 22.8991C3.54086 22.879 3.4191 22.8038 3.34027 22.6911C3.25 22.562 3.25 22.3477 3.25 21.9191V9.25001C3.25 6.44974 3.25 5.04961 3.79497 3.98005C4.27433 3.03924 5.03924 2.27433 5.98005 1.79497ZM16.0303 8.53033C16.3232 8.23744 16.3232 7.76256 16.0303 7.46967C15.7374 7.17678 15.2626 7.17678 14.9697 7.46967L11 11.4393L9.53033 9.96967C9.23744 9.67678 8.76256 9.67678 8.46967 9.96967C8.17678 10.2626 8.17678 10.7374 8.46967 11.0303L10.4697 13.0303C10.7626 13.3232 11.2374 13.3232 11.5303 13.0303L16.0303 8.53033Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M20 13V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622C8.37458 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L20 22V18M9 10.5L11 12.5L15.5 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 10.5L11 12.5L15.5 8M20 22V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622C8.37458 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L20 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M11.25 1.25C8.44974 1.25 7.04961 1.25 5.98005 1.79497C5.03924 2.27433 4.27433 3.03924 3.79497 3.98005C3.25 5.04961 3.25 6.44974 3.25 9.25001V20.6247C3.25 21.4819 3.25 21.9105 3.43054 22.1686C3.58819 22.394 3.83173 22.5445 4.10384 22.5848C4.41546 22.6308 4.79882 22.4391 5.56554 22.0558L6.27566 21.7007C8.37458 20.6512 9.42404 20.1265 10.5248 19.92C11.4998 19.7371 12.5002 19.7371 13.4752 19.92C14.576 20.1265 15.6254 20.6512 17.7243 21.7007L18.4345 22.0558C19.2012 22.4391 19.5845 22.6308 19.8962 22.5848C20.1683 22.5445 20.4118 22.394 20.5695 22.1686C20.75 21.9105 20.75 21.4819 20.75 20.6247V9.25C20.75 6.44974 20.75 5.04961 20.205 3.98005C19.7257 3.03924 18.9608 2.27433 18.02 1.79497C16.9504 1.25 15.5503 1.25 12.75 1.25H11.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.0303 7.46967C16.3232 7.76256 16.3232 8.23744 16.0303 8.53033L11.5303 13.0303C11.2374 13.3232 10.7626 13.3232 10.4697 13.0303L8.46967 11.0303C8.17678 10.7374 8.17678 10.2626 8.46967 9.96967C8.76256 9.67678 9.23744 9.67678 9.53033 9.96967L11 11.4393L14.9697 7.46967C15.2626 7.17678 15.7374 7.17678 16.0303 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
